<template>
  <div>
    <el-card>
      <detail-page :code="params.code" :disabled="isDisableEditForm" />
    </el-card>
  </div>
</template>
<script>
import DetailPage from "../components/detail-page"
export default {
  name: "purchase-pendingPlanMaterial-detail",
  components: { DetailPage },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    isDisableEditForm() {
      return this.pageType === "detail"
    },
  },
}
</script>
